import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import './Package.css';
import {baseURL} from './../../config';
import Modal from './../UI/Modal/Modal';
import Product from './../Product/Product';

class Package extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activedProduct: null,
      modalShow: false,
      productIdModal: 1
    }
    this.forceClose = false;
    this.activeProduct = this.activeProduct.bind(this);
    this.deactiveProduct = this.deactiveProduct.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal(e) {  
    // console.log("inner open");  
    const {skreen} = this.props;
    if(skreen === "desktop"){
      this.setState({
        modalShow: true,
        productIdModal:e.target.dataset['id']
      });
    }
  }

  closeModal() {
    // console.log("inner close");
    const {skreen} = this.props;
    if(skreen === "desktop"){
      this.setState({
        modalShow: false,
        productIdModal: 1
      });
    }
  }

  
  activeProduct(e) {
    this.setState({
      activedProduct: e.target.dataset['id']
    })
  }
  deactiveProduct(e) {
    this.setState({
      activedProduct: null
    })
  }
  componentWillReceiveProps(){
    this.forceClose = this.props.forceClose
  }
  componentDidUpdate(){
    // console.log('pk did update');
    if(this.forceClose===true) {
      this.forceClose = false
      this.closeModal();
    }
  }

  render() {
    // console.log("pk render", this.props);
    
    
    const {skreen, packs} = this.props;
    const {activedProduct} = this.state;
    let output = null;

    let modal = null;
    if(skreen === "desktop"){
      modal = <Modal 
        style={{
          backdrop:{backgroundColor:'transparent'},
          modal:{width:'100%', height:'100%', top:0, left:0, backgroundColor:'rgb(250, 250, 250)'},
          close:{backgroundColor: 'rgb(0, 0, 0, 0.6)', top:-62, left:0, width:'100%', textAlign:'left', borderRadius: 4}
        }} 
        iconClose = {<i className="fas fa-arrow-left"></i>}
        show={this.state.modalShow} 
        modalClosed={this.closeModal}>
          <Product packs={packs} skreen={skreen} match={{params:{packageID:this.props.match.params.packageID, productID:this.state.productIdModal}}}></Product>
      </Modal>
    }

    
    const pack = packs.find(pack => {
      return pack.id == this.props.match.params.packageID;
    });
    
    if(pack) {
      let tooltips = null;
      tooltips = pack.products.map(
        product => {
          const className = (product.id==activedProduct) ? 'tooltip active': 'tooltip';
          const style = (activedProduct==null || product.id==activedProduct) ? null: {backgroundColor:'rgba(100,100,100,0.5', color:'rgba(255,255,255,0.5)', borderColor:'rgba(255,255,255,0.5)'};
          return (
            <div
            data-id={product.id} 
            onMouseOver={this.activeProduct}
            onMouseOut={this.deactiveProduct} 
            key={product.id} 
            className={className} 
            style={{top:product.top, left:product.left, transform:'scale(1)', ...style}}>
              {product.id}
            </div>
          );
        } 
      );
      output = (
        <div className="package" style={{backgroundColor:'black'}}>
          <div className="package-image" style={{position:'relative'}}>
            <img src={`${baseURL}/images/packages/${pack.picture}`} style={{position:'relative', width:'100%', height:'100%'}}></img>
            {tooltips}
          </div>
          
          <div className="package-products">
            <div className="brand-wrapper" style={{ width:'100%', padding:'40px 20px 10px'}}>
              <div className="brand" style={{border:'none'}}>
              <div className="brand-picture" style={{width:60, height:60, backgroundColor:'white', color:'black', fontSize:12, lineHeight:'55px', textAlign:'center'}}>TULAROSA</div>
              <p className="brand-name" style={{color:'white', lineHeight:'55px'}}> tularosalabel</p>
              </div>
            </div>
            <div style={{display:'flex', flexWrap: 'wrap'}} className="package-products-list">
            {
              pack.products.map(product => {
                let style = (activedProduct==null || product.id==activedProduct) ? {display:'none'} : {display:'block'};
                return (
                  <div  key={product.id}  style={{position:'relative'}} className="product-preview">
                    <div className="product-image-wrapper">
                      <div className="product-image"
                      data-id={product.id} 
                      onMouseOver={this.activeProduct}
                      onMouseOut={this.deactiveProduct}
                      style={{backgroundImage:`url("${baseURL}/images/products/${product.picture}")`}}>
                      </div>
                    </div>

                    <div style={{display:'flex', flexWrap:'wrap', justifyContent:'space-between'}}>
                      <div style={{width:'40%', color:'white', padding:'10px'}} className="product-price">{product.price}$</div>
                      <div style={{width:'50%', margin:'4px', textAlign:'center'}} className="buy-product">
                        <Link to={`/product/${pack.id}/${product.id}`}>
                        <div className="buy-product-button" 
                        data-id={product.id} onClick={this.openModal}>Buy</div>
                        </Link>
                    </div>
                    </div>
                    <p style={{color:'white', padding:'8px 10px'}} className="product-title">{product.title}</p>
                    <div style={{position:'absolute',top:0, left:0, width:'100%', height:'100%', backgroundColor:'rgba(0,0,0,0.8)', ...style}}></div>
                  </div>
                )
              })
            }
            </div>
            <p style={{fontSize:14, color:'white', padding:'30px', paddingBottom:100}}>a golden soul ✨ | @gabbyshaoni in the clarisa top + bottom - link in bio to shop</p>

          </div>
          {modal}
        </div>
      );
    }     
    return output;
  }
}

export default Package;
